<template>
  <div>
    <homelogo />
    <v-img src="@/assets/Donaciones/imagen_donaciones_cabezote.jpg"></v-img>
    <v-row class="hidden-md-and-up">
      <v-col lg="6" md="6" sm="12" xs="12" cols="12">
        <v-row>
          <v-col cols="12">
            <div class="text-center px-6">
              <h1 class="text-center titlesDonation">Para Donar</h1>
              <br />
              <p class="parrafos1 px-10">
                Si en tu Empresa tienes equipos tecnológicos a Donaciones
                como: portátiles, computadores de escritorio
                o tablets en desuso "dónalos" nosotros nos
                encargamos de reacondicionarlos y llevarlos a
                los sectores menos favorecidos de Colombia.
              </p>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-center">
              <!-- <v-img src="@/assets/Donaciones/fomulario_para_postularme.png"> -->
              <div class="bckForm text-center">
                <form @submit.prevent="sendEmail" class="contact-form">
                  <v-text-field
                    label="Institución o Nombre"
                    filled
                    outlined
                    rounded
                    solo
                    full-width
                    name="nombre"
                    v-model="nombreDonar1"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Número de identificación"
                    filled
                    outlined
                    rounded
                    solo
                    name="identificacion"
                    v-model="identificacionDonar1"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Correo Electronico"
                    filled
                    outlined
                    rounded
                    solo
                    name="correo"
                    v-model="correoDonar1"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Teléfono / Celular"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="telefonoDonar1"
                    name="telefono"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Ciudad"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="ciudadDonar1"
                    name="ciudad"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Dirección"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="direccionDonar1"
                    name="direccion"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-textarea
                    label="Comentarios"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="comentariosDonar1"
                    name="comentarios"
                    color="orange"
                    class="borderorange"
                    height="250"
                    hide-details
                  ></v-textarea>
                  <br />
                  <v-btn
                    width="100%"
                    height="55"
                    rounded
                    color="orange"
                    class="mx-auto white--text"
                    type="submit"
                  >Enviar</v-btn>
                  <tooltipbtn />
                  <!-- <v-btn @click="clear">clear</v-btn> -->
                </form>
              </div>
              <!-- </v-img> -->
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="6" md="6" sm="12" xs="12" cols="12">
        <v-row>
          <v-col cols="12">
            <div class="text-center px-6">
              <h2 class="text-center titlesDonation">Para Postularme a Donaciones</h2>
              <br />
              <p class="parrafos1 px-10">
                Nuestra fundación quiere apoyar a instituciones que desarrollen 
                acciones sociales con niños y niñas  que se encuentren dentro del 
                periodo de primera infancia, cuéntanos tu historia, nuestro equipo 
                te contactará para más información.
                <!-- Nuestra fundación quiere apoyar a instituciones que desarrollen 
                acciones sociales con niños y niñas  que se encuentren dentro del 
                periodo de primera infancia, cuéntanos tu historia, nuestro equipo te contactará para más información. -->
                <!-- Su organización debe trabajar con niños de primera
                infancia. -->
              </p>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-center">
              <br />
              <div class="bckForm text-center">
                <form @submit.prevent="sendEmail" class="contact-form">
                  <v-col cols="12">
                    <v-text-field
                      label="Institución o Nombre"
                      filled
                      outlined
                      rounded
                      solo
                      full-width
                      v-model="nombreDonar2"
                      name="nombre"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Número de identificación"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="identificacionDonar2"
                      name="identificacion"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Correo Electronico"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="correoDonar2"
                      name="correo"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Teléfono / Celular"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="telefonoDonar2"
                      name="telefono"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Ciudad"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="ciudadDonar2"
                      name="ciudad"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Dirección"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="direccionDonar2"
                      name="direccion"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      label="Comentarios"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="comentariosDonar2"
                      name="comentarios"
                      color="orange"
                      class="borderorange"
                      height="250"
                      hide-details
                    ></v-textarea>
                  </v-col>
                  <v-btn
                    width="100%"
                    height="55"
                    rounded
                    color="orange"
                    class="mx-auto white--text"
                    type="submit"
                  >Enviar</v-btn>
                  <tooltipbtn />
                  <!-- <v-btn @click="clear">clear</v-btn> -->
                </form>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="hidden-sm-and-down">
      <v-col cols="12">
        <v-row>
          <v-col  cols="6">
            <div class="text-center px-6">
              <h1 class="text-center titlesDonation">Para Donar</h1>
              <br />
              <p class="parrafos1 px-10">
                Si en tu Empresa tienes equipos tecnológicos a Donaciones
                como: portátiles, computadores de escritorio
                o tablets en desuso "dónalos" nosotros nos
                encargamos de reacondicionarlos y llevarlos a
                los sectores menos favorecidos de Colombia.
              </p>
            </div>
          </v-col>
          <v-col  cols="6">
            <div class="text-center px-6">
              <h2 class="text-center titlesDonation">Para Postularme a Donaciones</h2>
              <br />
              <p class="parrafos1 px-10">
                Nuestra fundación quiere apoyar a instituciones que desarrollen 
                acciones sociales con niños y niñas  que se encuentren dentro del 
                periodo de primera infancia, cuéntanos tu historia, nuestro equipo 
                te contactará para más información.
                <!-- Su organización debe trabajar con niños de primera
                infancia. -->
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col  cols="12">
        <v-row>
          <v-col lg="6" md="6" sm="12" xs="12" cols="12">
            <div class="text-center">
              <!-- <v-img src="@/assets/Donaciones/fomulario_para_postularme.png"> -->
              <div class="bckForm text-center">
                <form @submit.prevent="sendEmail" class="contact-form">
                  <v-text-field
                    label="Institución o Nombre"
                    filled
                    outlined
                    rounded
                    solo
                    full-width
                    name="nombre"
                    v-model="nombreDonar1"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Número de identificación"
                    filled
                    outlined
                    rounded
                    solo
                    name="identificacion"
                    v-model="identificacionDonar1"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Correo Electronico"
                    filled
                    outlined
                    rounded
                    solo
                    name="correo"
                    v-model="correoDonar1"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Teléfono / Celular"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="telefonoDonar1"
                    name="telefono"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Ciudad"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="ciudadDonar1"
                    name="ciudad"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-text-field
                    label="Dirección"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="direccionDonar1"
                    name="direccion"
                    color="orange"
                    class="borderorange"
                    hide-details
                  ></v-text-field>
                  <br />
                  <v-textarea
                    label="Comentarios"
                    filled
                    outlined
                    rounded
                    solo
                    v-model="comentariosDonar1"
                    name="comentarios"
                    color="orange"
                    class="borderorange"
                    height="250"
                    hide-details
                  ></v-textarea>
                  <br />
                  <v-btn
                    width="100%"
                    height="55"
                    rounded
                    color="orange"
                    class="mx-auto white--text"
                    type="submit"
                  >Enviar</v-btn>
                  <tooltipbtn />
                  <!-- <v-btn @click="clear">clear</v-btn> -->
                </form>
              </div>
              <!-- </v-img> -->
            </div>
          </v-col>
          <v-col lg="6" md="6" sm="12" xs="12" cols="12">
            <div class="text-center">
              <!-- <br /> -->
              <div class="bckForm text-center">
                <form @submit.prevent="sendEmail" class="contact-form">
                  <v-col cols="12">
                    <v-text-field
                      label="Institución o Nombre"
                      filled
                      outlined
                      rounded
                      solo
                      full-width
                      v-model="nombreDonar2"
                      name="nombre"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Número de identificación"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="identificacionDonar2"
                      name="identificacion"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Correo Electronico"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="correoDonar2"
                      name="correo"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Teléfono / Celular"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="telefonoDonar2"
                      name="telefono"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Ciudad"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="ciudadDonar2"
                      name="ciudad"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Dirección"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="direccionDonar2"
                      name="direccion"
                      color="orange"
                      class="borderorange"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      label="Comentarios"
                      filled
                      outlined
                      rounded
                      solo
                      v-model="comentariosDonar2"
                      name="comentarios"
                      color="orange"
                      class="borderorange"
                      height="250"
                      hide-details
                    ></v-textarea>
                  </v-col>
                  <v-btn
                    width="100%"
                    height="55"
                    rounded
                    color="orange"
                    class="mx-auto white--text"
                    type="submit"
                  >Enviar</v-btn>
                  <tooltipbtn />
                  <!-- <v-btn @click="clear">clear</v-btn> -->
                </form>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" vertical :color="color" top>
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import emailjs from "emailjs-com";
import homelogo from "@/components/homelogo/homelogo.vue";
import tooltipbtn from "@/components/tooltip.vue";
export default {
  components: {
    homelogo,
    tooltipbtn
  },
  data: () => ({
    color: "green",
    text: "",
    snackbar: false,
    nombreDonar1: null,
    identificacionDonar1: null,
    correoDonar1: null,
    telefonoDonar1: null,
    ciudadDonar1: null,
    direccionDonar1: null,
    comentariosDonar1: null,
    nombreDonar2: null,
    identificacionDonar2: null,
    correoDonar2: null,
    telefonoDonar2: null,
    ciudadDonar2: null,
    direccionDonar2: null,
    comentariosDonar2: null,
    items: [
      {
        text: "RAEE.",
        icon: "@/assets/comoLoHacemos/como_lo_hacemos/raee_link.png",
        href: "#raee"
      },
      {
        text: "Reacondicionarte.",
        icon:
          "@/assets/comoLoHacemos/como_lo_hacemos/reacondicionarte_link.png",
        href: "#reacondicionar"
      },
      {
        text: "Economia circular",
        icon:
          "@/assets/comoLoHacemos/como_lo_hacemos/economia_circular_link.png",
        href: "#economiaCircular"
      },
      {
        text: "Cómo lo hacemos.",
        icon: "@/assets/comoLoHacemos/como_lo_hacemos/como_lo_hacemos_link.png",
        href: "#comoLoHacemos"
      }
    ],
    itemsRaee: [
      { icon: "", text: "Grandes Electrodomésticos." },
      { icon: "", text: "Equipos informáticos y telecomunicación." },
      { icon: "", text: "Pequeños Electrodomésticos" },
      { icon: "", text: "Aparatos electrónicos de consumo." },
      { icon: "", text: "Herramientas eléctricas." }
    ]
  }),
  methods: {
    recaptcha() {
      return this.$recaptcha('login').then((token) => {
        console.log(token) // Will print the token
      })
      // .catch((e)=>{
        // clave site
        // 6LesXK4ZAAAAAN8wzzIXMTTjjt0-iZhnROb90Y0A
        //clave secreta
        // 6LesXK4ZAAAAAHd0bbwiX72KFfkdXkwgJiHOfpZY
        // console.log(e)
      // })
    },
    sendEmail(e) {
      console.log(e.target);
      this.recaptcha().then(()=>{
      emailjs
        .sendForm(
          "gmail",
          "templatedonation",
          e.target,
          "Ef4pW9SP33f_8T-Rv"
        )
        .then(
          result => {
            this.color = "green";
            this.text = "Su correo ha sido enviado";
            this.snackbar = true;
            (this.nombreDonar1 = null),
              (this.identificacionDonar1 = null),
              (this.correoDonar1 = null),
              (this.telefonoDonar1 = null),
              (this.ciudadDonar1 = null),
              (this.direccionDonar1 = null),
              (this.comentariosDonar1 = null),
              (this.nombreDonar2 = null),
              (this.identificacionDonar2 = null),
              (this.correoDonar2 = null),
              (this.telefonoDonar2 = null),
              (this.ciudadDonar2 = null),
              (this.direccionDonar2 = null),
              (this.comentariosDonar2 = null),
              console.log("SUCCESS!", result.status, result.text);
          },
          error => {
            this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            this.snackbar = true;
            console.log("FAILED...", error);
          }
        );
    }).catch((e)=>{
         this.text =
              "Se ha generado un error por favor comuníquese con el administrador";
            this.color = "red";
            this.snackbar = true;
            console.log("FAILED...", e);
      })
      },
    onClick(e, item) {
      e.stopPropagation();

      if (item.to || !item.href) return;

      this.$vuetify.goTo(item.href.endsWith("!") ? 0 : item.href);
    },
    onclickreturn() {
      this.$vuetify.goTo("#init");
    }
  }
};
</script>
<style scoped>
.imglogo {
  position: absolute;
  width: 20%;
  /* background: transparent; */
  z-index: 99;
}
.floatcenter {
  display: flex;
  display: -webkit-flex;
  margin: auto;
}
.back {
  padding: 18%;
  background-image: url("../assets/Donaciones/fomulario_para_postularme.png");
  background-size: cover;
  /* background-size: auto; */
}
/* #home > div > div > div.row > div:nth-child(1) > div.v-card__text > div > div:nth-child(1) > div > div > div.v-input__slot > fieldset */
.borderorange {
  border-color: rgb(255, 144, 0);
  box-shadow: 1px 1px 1px rgb(255, 144, 0) inset, 0 0 2px rgba(255, 144, 0);
  outline: 0 none;
  outline-color: orange;
  /* width: 400px; */
}
fieldset {
  border-color: rgb(255, 144, 0) !important;
}
.bckForm {
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 15%;
  padding-bottom: 20%;
  background-image: url("../assets/formularios/formulario_donaciones.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-size: 100% 100%;
}
</style>